import * as React from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Auth } from 'aws-amplify'

const timeout = Number(process.env.REACT_APP_SESSION_TIMEOUT || 60)
const sessionTimeout = timeout * 60 * 1000

export const checkTimeout = () => {
  const currentTime = Date.now()
  let lastActionTime = localStorage.getItem('chrofyLastActionTime')
  if (!lastActionTime) return false

  const _lastActionTime = Number(lastActionTime)
  lastActionTime = isNaN(_lastActionTime) ? 0 : _lastActionTime

  return currentTime - lastActionTime > sessionTimeout
}

/** Same keys as Logout `dispatchLogout` — single place to keep in sync. */
export const clearChrofySessionStorageKeys = () => {
  localStorage.removeItem('chrofyLastWarmupTime')
  localStorage.removeItem('chrofyLastActionTime')
}

const redirectToLogout = () => {
  window.location.href = '/logout'
}

/**
 * Validates Cognito session, enforces idle timeout, bumps last-action time on success. On failure: clears Redux session
 * storage keys, signs out, redirects to /logout.
 *
 * @param {import('redux').Dispatch} dispatch
 */
export const runSessionCheck = async (dispatch) => {
  try {
    await Auth.currentSession()

    if (checkTimeout()) {
      dispatch({ type: 'SET_LOGOUT' })
      clearChrofySessionStorageKeys()
      try {
        await Auth.signOut()
      } catch (e) {
        console.error(e)
      }
      redirectToLogout()
      return
    }

    localStorage.setItem('chrofyLastActionTime', Date.now())
  } catch (e) {
    console.error(e)
    dispatch({ type: 'SET_LOGOUT' })
    clearChrofySessionStorageKeys()
    try {
      await Auth.signOut()
    } catch (signErr) {
      console.error(signErr)
    }
    redirectToLogout()
  }
}

export const useSessionUtil = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  React.useEffect(() => {
    void runSessionCheck(dispatch)
  }, [dispatch, location.pathname])
}
